import React, { useState, useEffect } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import styled from "styled-components";
import { Button, DateDisplay } from "../../../components";
import { Main } from "../../../components/utilities";
import useAgedDebtorsMonthlyFeeDetails from "../hooks/useAgedDebtorsMonthlyFeeDetails";
import { VirtualTable } from "../../../components/tables";
import AgedDebtorDetailTableRow from "./AgedDebtorDetailTableRow";
import TableColumnHeader from "../../clientdashboardloginstable/components/TableColumnHeader";
import { StandardTableSortableHeader } from "../../../components/tables/StandardTable";
import { ThemedSpan } from "../../../components/utilities";


const AgedDebtorsAgedMonthBreakdownModal = ({ show, onHide, detailedRequest }) => {

     const { 
        clear: refreshTable,
        data,
        isError,
        error,
        hasMore,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        sort,
        sortTable,
        totalCount
    } = useAgedDebtorsMonthlyFeeDetails();

    //const request = detailedRequest;

    React.useEffect(() => {
        if(detailedRequest !== null && detailedRequest.feeGroupIds !== undefined){
            //console.log("Refreshing Table in modal:", detailedRequest);
            //console.log("this is where it's throwing the error");
            //console.log('data in popup',data);
            refreshTable(detailedRequest);  
        }
        else{
            //console.log("Detailed Request null:", detailedRequest);
        }
    }, [detailedRequest]);

    

    // const { data, error, isLoading, isFetching } = rest;
   
    const agedMonthText = moment(detailedRequest?.agedMonth).format('MMM-YY');
    const archiveMonthText = moment(detailedRequest?.archiveMonth).format('MMM-YY');
    //console.log("Data:", data);
    
    //isError = true;
    //error = 'something went wrong';
    //console.log('error ', error, 'isError ',isError);
    //console.log('isNextPageLoading',isNextPageLoading);
    //console.log('loadMore',loadMore);

    if (isError && !isNextPageLoading){
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={refreshTable(detailedRequest)} />
        </ErrorMessageWrapper>
    }

    {/*if (totalCount === 0)
        return <Main>
            <div className="p-3">
                    {`No Archived Fee Transactions found for Archived Month: ${archiveMonthText} Aged Debt Month: ${agedMonthText}`}
            </div>
        </Main>*/}


//console.log('some debtor detail stuff coming from hook: refreshTable ', refreshTable, ' hasMore', hasMore, 'isNextPageLoading ', isNextPageLoading, ' isNewRecords ', isNewRecords, ' isRowLoaded ', isRowLoaded, ' loadMore', loadMore, ' isNewRecords ', isNewRecords, ' newRecordsSinceCache ', newRecordsSinceCache, ' totalCount ', totalCount);
//console.log('loadMore', loadMore);
//console.log('isRowLoaded', isRowLoaded(21));
    return (
        <React.Fragment>
            <Modal size="xl" backdrop="static" onHide={onHide} centered show={show}>
                <Modal.Header closeButton>
                    <Modal.Title>{`Fees - Archived Month: ${archiveMonthText} Aged Debt Month: ${agedMonthText}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*<React.Fragment>*/}
                        {/*<section className="px-4 my-3 h-100">*/}
                            {/*<div style={{ minHeight: '100px', height: '700px' }}>*/}
                            <div style={{ minHeight: '500px' }}>
                                <VirtualTable
                                    enableScrollTracking={false}
                                    loadMoreItems={loadMore}
                                    row={AgedDebtorDetailTableRow}
                                    //itemSize={20}
                                    itemSize={50}
                                    //itemCount={data.length === totalCount ? totalCount : data.length + 10}
                                    itemCount={totalCount}
                                    itemData={ data }
                                    isItemLoaded={isRowLoaded}
                                    error={error}
                                    isLoading={isNextPageLoading}
                                    header={(
                                        <thead>
                                            <tr>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="originalFeeDate">Date</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="feeType">Type</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="provider" >Provider</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="sales">Sales</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="debt">Debt</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="masterAccountName">Client</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="applicationId">Application</StandardTableSortableHeader>
                                                <StandardTableSortableHeader sort={sort} sortTable={sortTable} property="applicationDescription">Desc.</StandardTableSortableHeader>
                                            </tr>
                                        </thead>
                                    )}
                                    footer={
                                        <div className="p-2 p-sticky">
                                            <ThemedSpan>{totalCount} Items(s)</ThemedSpan>
                                        </div>
                                    }
                                />
                            </div>

                            {/*</section>*/}
                        {/*</React.Fragment>*/}
                    </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="light" onClick={onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )

};
export default AgedDebtorsAgedMonthBreakdownModal;